<script>
import publishFilter from './publishFilter.vue'
import publishEditor from './publishEditor.vue'
import dragdrop from '../common/dragdrop.vue'
import dragula from 'dragula'
import debounce from 'debounce'
import settings from './publishSettings.vue'
import { elementsSettingsDefinition, elementsSettingsDefaults } from '../settings/settingsDefinition'
import toaster from "../../common/toaster";
import {widgetSettingsAndPropertiesToQueryString, widgetSettingsAndPropertiesToStructure} from '../../../../utils/widget';
import {getLayerIdLocalStorageKey, getPublishFilterLocalStorageKey} from "../../../../utils/publish";

export default {
    props: {
        /** @type {PublishLayer_Active[]} */
        active_layers_initial: Array,
        /** @type {PublishLayer_All[]} */
        all_layers: Array,
        /** @type {'1' | undefined} */
        approvePrivilege: String,
        insert_data: [Object, Array],
        presetsRaw: Object,
        /** @type {ScreensData} */
        screensData: Object,
        stretch: String,
        transition: String,
        useCalendar: {},

        projectSettingsIncomplete: Boolean,
        userStatusErrored: Boolean,
    },
    components: {
        publishFilter,
        publishEditor,
        dragdrop,
        settings
    },
    data: function() {
        return {
            t_template_link_fail: Lang.langGet('Failed to link template!'),
            t_campaign_link_fail: Lang.langGet('Failed to link campaign!'),
            t_endless_loop: Lang.langGet('Checking for endless loop. This may take a while.'),
            t_endless_loop_ok: Lang.langGet('No endless loop detected. Element will be inserted.'),
            t_endless_loop_fail: Lang.langGet('You are not allowed to add the element, an endless loop was detected:'),
            t_insert_fail: Lang.langGet('Failed to add element to layer.'),
            dragulaObject: null,
            active_layer: {},
            active_layers: this.active_layers_initial,
            active_visible_element_index: -1,
            active_element: {
                data: {screens: [], screengroups: [], name: '', valid_time_from: '', valid_time_to: '', valid_from: [], valid_to: [], weekdays: []}
            },
            tapStructureId: -1,
            grid: '2cols',
            mode: '',
            layout: 'editor-right',
            startDragdropCollapsed: false,
            startSettingsCollapsed: false,
            startDragdropActive: false,
            startSettingsActive: false,
            inserted: false,
            layerkey: -1,
            creator_errors: [],
            windowInfo: {},
            layoutInfo: {},
            opened_panels: [],
            dragdropCollapsed: false,
            loadingProcess: false,
            publishError: false,
        }
    },
    watch: {
        grid: function(val) {
            localStorage.setItem('publish-grid-' + Laravel.activeProject, val)
            this.appendDragdropAndSettings()
        },
        active_layers_initial: {
            /** @param val {PublishLayer_Active[]} */
            handler(val) {
                val.forEach(layer => layer.text = layer.text.replaceAmpGtLt())
                this.active_layers = val
            },
            immediate: true
        },
        all_layers: {
            /** @param val {PublishLayer_All[]} */
            handler(val) {
                val.forEach(layer => layer.text = layer.text.replaceAmpGtLt())
            },
            immediate: true
        }
    },
    computed: {
        creatorStyles: function() {
            let height = (Math.max(this.layoutInfo.minHeight ?? 692, this.windowInfo.contentHeight ?? 692))

            return {
                height: `${height}px`
            }
        },
        all_layer_layers() {
            return Laravel.switch_off_times ? this.all_layers.filter(o => o.nr !== 0) : this.all_layers
        },
        calendarView() {
            if (!this.useCalendar) {
                return false;
            }
            if (_.isUndefined(this.active_layer.is_calendar)) {
                const layer = this.getDefaultLayer();
                return layer?.is_calendar;
            }

            return this.active_layer.is_calendar;
        },
        publishingDisabled() {
            if (this.projectSettingsIncomplete) return true;
            if (this.publishError) return true;

            return false;
        }
    },
    methods: {
        handleChangeGrid(newGrid) {
            this.grid = newGrid;
        },
        getDefaultLayer() {
            const key = getLayerIdLocalStorageKey();
            const lastLayerId = JSON.parse(localStorage.getItem(key));
            if (_.isNil(lastLayerId)) return this.all_layers[0];

            const layer = this.all_layers.find(layer => layer.value === lastLayerId);
            if (!layer) {
                return this.all_layers[0];
            }

            return layer;
        },
        /** @param element {PublishElement} */
        redirectToEditors(element) {
            if (element.data.type === 'template') {
                if (element.data.state === 'link') {
                    axios.post('/content/campaign/convert', {
                        id: element.data.id,
                        project: Laravel.activeProject,
                        type: element.data.type
                    }).then(() => {
                        axios.post('/content/inline-info/store', {
                            parentType: "publish",
                            parentLayerLimitation: JSON.stringify([this.active_layer.id.toString()]),
                            parentUsergroupLimitation: JSON.stringify([]),
                        }).then(() => {
                            window.location = '/content/template/edit-inline/' + element.data.id + '/latest?publish=' + element.id;
                        });
                    });
                } else {
                    axios.post('/content/inline-info/store', {
                        parentType: "publish",
                        parentLayerLimitation: JSON.stringify([this.active_layer.id.toString()]),
                        parentUsergroupLimitation: JSON.stringify([]),
                    }).then(() => {
                        window.location = '/content/template/edit-inline/' + element.data.id + '/latest?publish=' + element.id;
                    });
                }
            } else {
                axios.post('/content/inline-info/store', {
                    parentType: "publish",
                    parentLayerLimitation: JSON.stringify([this.active_layer.id.toString()]),
                    parentUsergroupLimitation: JSON.stringify([]),
                }).then(() => {
                    window.location = '/content/campaign/edit-inline/' + element.data.id + '/latest?publish=' + element.id;
                });
            }
        },
        processDrop(el, layerId, target, additionalProperties) {
            let dropping = true;

            EaseEventBus.fire('settingsActive');

            const elementData = $(el).find('.element-data');

            let id = elementData.data('file-id') || null;

            const type = elementData.data('type');
            const name = elementData.data('display-name') || '';

            const url = type === 'widget'
                ? (elementData.data('thumbnail') || null)
                : (elementData.data('preview-name') || null);

            this.catchDropsForWebElement(target, id, name);
            const structure = this.constructStructure(elementData, additionalProperties);

            const structures = [{ 'data': structure }];
            this.insertMissingFields(structures, true);

            if (type === 'template') {
                id = elementData.data('template-id') || null
                dropping = false

                axios.post('/content/template/link', {
                    project: Laravel.activeProject,
                    id: id
                }).then((response) => {
                    id = response.data.data.id
                    structure.id = id
                    if (target.classList.contains('alternative-dropzone')) {
                        EaseEventBus.fire('alternativeElementUpdate', { id: id, url: url, type: type, name: name })
                    } else {
                        this.addElementToLayer(layerId, structure)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login'
                    }

                    toaster.error(this.t_template_link_fail)
                })
            }

            if (type === 'campaign') {
                id = elementData.data('campaign-id') || null
                dropping = false;

                axios.post('/content/campaign/link', {
                    project: Laravel.activeProject,
                    id: id
                }).then((response) => {
                    id = response.data.data.id
                    structure.id = id
                    if (target.classList.contains('alternative-dropzone')) {
                        EaseEventBus.fire('alternativeElementUpdate', { id: id, url: url, type: type, name: name });
                    } else {
                        this.addElementToLayer(layerId, structure);
                    }
                }).catch((error) => {
                    toaster.error(this.t_campaign_link_fail);
                })
            }

            if (target.classList.contains('dragdrop-placeholder') && dropping && type.indexOf('placeholder') === -1) {
                this.addElementToLayer(layerId, structure);
            }

            if (target.classList.contains('publish-calendar-container') && dropping && type.indexOf('placeholder') === -1) {
                structure.literal_times = true;
                this.addElementToLayer(layerId, structure);
            }

            if (target.classList.contains('alternative-dropzone') && dropping) {
                EaseEventBus.fire('alternativeElementUpdate', { id: id, url: url, type: type, name: name });
            }

            switch (type) {
                case 'mediaplaceholder':
                    window.location = '/content/mediapool?add=' + type.replace('placeholder', '');
                    break;
                case 'templateplaceholder':
                    this.handleTemplateInlineAdd(structure);
                    break;
                case 'campaignplaceholder':
                    this.handleCampaignInlineAdd(structure);
                    break;
            }

            // el.remove()
            EaseEventBus.fire('dragging', false);
        },
        appendDragdropAndSettings: function() {
            if (this.grid === '2cols') {
                document.getElementById('dragdrop-settings-col').appendChild(document.getElementById('dragdrop-col'))
                document.getElementById('dragdrop-settings-col').appendChild(document.getElementById('settings-col'))
            } else {
                document.getElementById('creator-row').appendChild(document.getElementById('dragdrop-col'))
                document.getElementById('creator-row').appendChild(document.getElementById('settings-col'))
            }
        },
        addElementToLayer: debounce(function(layerId, structure) {
            if (typeof layerId === 'undefined' || typeof structure === 'undefined') {
                EaseEventBus.fire('finishedLoadingLayer')
                return;
            }

            const filter = JSON.parse(localStorage.getItem(getPublishFilterLocalStorageKey()));

            // Backup default screen if none was ever selected (e.g. new projects)
            if (this.active_layer.is_calendar && !filter?.screen) {
                filter.screen = this.screensData.screens[0].value.toString();
            }

            if ('screen' in filter) {
                if (filter['screen'] === '') {
                    if (filter['screengroup'] === '0') {
                        structure['screens'] = this.screensData.screengroupsToScreens[0].map(String);
                    } else {
                        structure['screengroups'] = filter['screengroup'] ? [filter['screengroup']] : []
                    }
                } else {
                    structure['screens'] = [filter['screen']]
                }
            }
            structure['approved'] = !!this.approvePrivilege

            if (_.indexOf(['template', 'campaign'], structure.type) !== -1) {
                toaster.warning(this.t_endless_loop)

                axios.post('/endless-loop-layer', {
                    project: Laravel.activeProject,
                    layer_id: layerId,
                    element: structure
                }).then(() => {
                    this.addElementToLayerInsert(layerId, structure)
                    toastr.clear();
                }).catch((error) => {
                    var escapedPath = $('<div>').text(error.response.data.data.path).html()
                    toastr.clear();
                    toaster.error(this.t_endless_loop_fail + ' ' + escapedPath)
                    EaseEventBus.fire('finishedLoadingLayer')
                })
            } else {
                this.addElementToLayerInsert(layerId, structure)
            }
        }, 200),
        addElementToLayerInsert(layerId, structure) {
            if (structure.type === 'other') {
                toaster.error(Lang.langGet('Elements of this type cannot be added.'));
                this.$refs.editor.reload();
                EaseEventBus.fire('finishedLoadingLayer');
                return;
            }
            axios.post('/content/publish/insert', {
                project: Laravel.activeProject,
                layer_id: layerId,
                element: structure,
                isadding: true
            }).then(() => {
                const layer = this.active_layer;
                this.tapStructureId = layer.elements?.length;

                if (this.$refs.editor?.reloadLayer) this.$refs.editor.reloadLayer('insert');
                else this.$refs.editor.reload();

                this.$nextTick(() => {
                    EaseEventBus.fire('reinitializeDragula');
                })
            }).catch((error) => {
                toaster.error(this.t_insert_fail)
                EaseEventBus.fire('finishedLoadingLayer');
            })
        },
        catchDropsForWebElement(target, id, name) {
            const layerId = +(target.dataset.key);
            if (target.classList.contains('attach-dropzone') && !layerId) {
                EaseEventBus.fire('activeElementDataLinkedFileAdd', {id: id, name: name});
                EaseEventBus.fire('dragging', false);
                EaseEventBus.fire('finishedLoadingLayer');
            }
        },
        constructStructure(elementData, additionalProperties = {}) {
            const id = elementData.data('file-id') || null;

            const type = elementData.data('type');
            const name = elementData.data('display-name') || '';
            const duration = elementData.data('duration');
            const validFrom = elementData.data('valid-from');
            const validTo = elementData.data('valid-to');
            const validTimeFrom = additionalProperties.validTimeFrom;
            const validTimeTo = additionalProperties.validTimeTo;

            const state = (_.indexOf(['campaign', 'template'], type) !== -1) ? 'link' : 'unknown';

            const url = type === 'widget'
                ? (elementData.data('thumbnail') || null)
                : (elementData.data('preview-name') || null);

            const baseStructure = {
                id: id,
                name: name,
                type: type,
                duration: typeof duration === 'undefined' ? null : duration,
                duration_original: typeof duration === 'undefined' ? null : duration,
                background_image: url,
                state: state,
                valid_from_placeholder: validFrom,
                valid_to_placeholder: validTo,
                valid_time_from: validTimeFrom,
                valid_time_to: validTimeTo,
            };

            if (additionalProperties.validFrom) {
                baseStructure.valid_from = additionalProperties.validFrom;
                baseStructure.valid_from_placeholder = additionalProperties.validFrom;
            }

            if (additionalProperties.validTo) {
                baseStructure.valid_to = additionalProperties.validTo;
                baseStructure.valid_to_placeholder = additionalProperties.validTo;
            }

            const structure = (type === 'widget')
                ? {
                    ...widgetSettingsAndPropertiesToStructure(elementData.data('settings')),
                    query_string: widgetSettingsAndPropertiesToQueryString(elementData.data('settings')),
                    ...baseStructure
                }
                : baseStructure;

            if (type === 'widget' && elementData.data('preview-name')) {
                structure['index_html'] = elementData.data('preview-name')
            }

            if (['picture', 'video', 'pdf', 'ppt', 'template', 'campaign'].includes(type)) {
                structure.transition = this.transition;
            }

            if(['picture', 'video', 'pdf', 'ppt'].includes(type)) {
                structure.stretch = this.stretch;
            }

            return structure;
        },
        setupDragula: function() {
            let containers = [
                document.querySelector('.dragdrop-content .mediapool-list'),
                document.querySelector('.dragdrop-content .template-list'),
                document.querySelector('.dragdrop-content .campaign-list'),
                document.querySelector('.dragdrop-content .drag-element-list'),
                document.querySelector('.dragdrop-content .widgets-list'),
                document.querySelector('.alternative-dropzone'),
                document.querySelector('.attach-dropzone')
            ]
            containers.concat(document.querySelectorAll('.dragdrop-placeholder'))
            let inactive = this.projectSettingsIncomplete

            let isLoadingProcess = () => this.loadingProcess;

            this.dragulaObject = dragula(containers, {
                isContainer: function(el) {
                    return el.classList.contains('dragdrop-placeholder')
                },
                moves: function(el, source, handle, sibling) {
                    return (!inactive && !isLoadingProcess() && !source.classList.contains('dragdrop-placeholder'))
                },
                accepts: function(el, target, source, sibling) {
                    let elementType = $(el).find('.element-data').data('type'),
                        dropzoneType = target.getAttribute('data-type')
                    let dropzoneTypes = []
                    if (typeof dropzoneType === 'string') {
                        dropzoneTypes = target.getAttribute('data-type').split('|')
                    }
                    return target.classList.contains('dragdrop-placeholder')
                        || (target.classList.contains('alternative-dropzone') && dropzoneTypes.includes(elementType))
                        || (target.classList.contains('attach-dropzone') && dropzoneTypes.includes(elementType))
                },
                copy: true,
                revertOnSpill: true,
                mirrorContainer: document.body
            }).on('drop', (el, target) => {
                EaseEventBus.fire('calendar-dragging', {}); // TODO refactor to a solution without EventBus
                const layerId = +(target.dataset.key);

                if (!target) {
                    EaseEventBus.fire('dragging', false);
                    return false;
                }

                this.processDrop(el, layerId, target);
            }).on('drag', function(el, source) {
                const data = $(el).find('.element-data').data();
                EaseEventBus.fire('calendar-dragging', data); // TODO refactor to a solution without EventBus
                EaseEventBus.fire('dragging', true);
            }).on('cancel', function(el, source) {
                EaseEventBus.fire('calendar-dragging', {}); // TODO refactor to a solution without EventBus
                EaseEventBus.fire('dragging', false);
                EaseEventBus.fire('finishedLoadingLayer');
            })
        },
        setStartCollapse: function() {
            let settingsCollapsed = false
            let dragdropCollapsed = false
            let settingsActive = false
            let dragdropActive = true
            if (this.grid === '2cols') {
                let savedSettingsCollapsed = localStorage.getItem('publish-settings-collapsed-' + Laravel.activeProject)
                let savedDragdropCollapsed = localStorage.getItem('publish-dragdrop-collapsed-' + Laravel.activeProject)
                if (savedSettingsCollapsed !== null && savedDragdropCollapsed !== null) {
                    settingsCollapsed = savedSettingsCollapsed === 'true'
                    dragdropCollapsed = savedDragdropCollapsed === 'true'
                }

                let savedSettingsActive = localStorage.getItem('publish-settings-active-' + Laravel.activeProject)
                if (savedSettingsActive !== null) {
                    settingsActive = savedSettingsActive === 'true'
                    dragdropActive = !settingsActive
                }
            }

            this.startSettingsCollapsed = settingsCollapsed
            this.startDragdropCollapsed = dragdropCollapsed
            this.startSettingsActive = settingsActive
            this.startDragdropActive = dragdropActive
        },
        processWindowSize: function() {
            let layoutInfo = this.layoutInfo
            if (layoutInfo) {
                let w = window.innerWidth
                let h = window.innerHeight

                let colWidth = (w - 2 * layoutInfo.wrapperLRpadding) / 12
                let maxHeight = h - layoutInfo.navBarHeight - layoutInfo.footerHeight

                let data = { 'colWidth': colWidth, 'contentHeight': maxHeight }
                this.windowInfo = data
                EaseEventBus.fire('windowInfo', data)
            }
        },
        spreadLayoutInfo: function() {
            let colLRpadding = 10, editorPadding = 36, editorFilterHeight = 48 + 1,
                editorLayersTitleHeight = 0, editorTitleHeight = 48 //+1: border, +10:margin
            let navBarHeight = 50, footerHeight = 39, wrapperTBpadding = 10, wrapperLRpadding = 10 - colLRpadding

            let minColWidth = 50
            let minHeight = 300

            let settingsTitleHeight = 48

            let dragdropNavTabsHeight = 50

            let data = {
                'navBarHeight': navBarHeight,
                'wrapperTBpadding': wrapperTBpadding,
                'wrapperLRpadding': wrapperLRpadding,
                'footerHeight': footerHeight,
                'colLRpadding': colLRpadding,

                'minColWidth': minColWidth,
                'minHeight': minHeight,

                'settingsTitleHeight': settingsTitleHeight,

                'dragdropNavTabsHeight': dragdropNavTabsHeight,

                'editorFilterHeight': editorFilterHeight,
                'editorLayersTitleHeight': editorLayersTitleHeight,
                'editorTitleHeight': editorTitleHeight,
                'editorPadding': editorPadding
            }
            this.layoutInfo = data
            EaseEventBus.fire('layoutInfo', data)
        },
        constructDataForInlineAdd(structure) {
            return {
                project: Laravel.activeProject,
                name: 'not-in-use',
                width: 1,
                height: 1,
                resolution: this.active_layer.width + 'x' + this.active_layer.height,
                format: aspectRatio(this.active_layer.width, this.active_layer.height),
                validFrom: structure.valid_from,
                validTo: structure.valid_to,
                validTimeFrom: structure.valid_time_from,
                validTimeTo: structure.valid_time_to,
            };
        },
        handleTemplateInlineAdd(structure) {
            const data = this.constructDataForInlineAdd(structure);
            axios.post('/content/template/inline-add', data).then((response) => {
                axios.post('/content/inline-info/store', {
                    parentType: 'publish',
                    parentLayerLimitation: JSON.stringify([this.active_layer.id]),
                    parentUsergroupLimitation: JSON.stringify([])
                }).then(() => {
                    window.location = '/content/template/edit-inline/' + response.data.data.id + '?add=inline';
                })
            }).catch(() => {
                toaster.error(this.t_insert_fail)
            })
        },
        handleCampaignInlineAdd(structure) {
            const data = this.constructDataForInlineAdd(structure);
            axios.post('/content/campaign/inline-add', data).then((response) => {
                axios.post('/content/inline-info/store', {
                    parentType: 'publish',
                    parentLayerLimitation: JSON.stringify([this.active_layer.id]),
                    parentUsergroupLimitation: JSON.stringify([])
                }).then(function() {
                    window.location = '/content/campaign/edit-inline/' + response.data.data.id + '?add=inline';
                })
            }).catch(() => {
                toaster.error(this.t_insert_fail)
            })
        },
        defaultValue: function(type, field, created) {
            let presetValue = null
            if (created && this.presetsRaw[type]) {
                presetValue = this.presetsRaw[type]['publish'] ? this.presetsRaw[type]['publish'][field] : null
                presetValue = presetValue ? presetValue : (this.presetsRaw[type]['all'] ? this.presetsRaw[type]['all'][field] : null)
            }

            if (presetValue) {
                return presetValue
            } else if (type in elementsSettingsDefaults && field in elementsSettingsDefaults[type]) {
                return elementsSettingsDefaults[type][field]
            } else if ('default' in elementsSettingsDefaults && field in elementsSettingsDefaults['default']) {
                return elementsSettingsDefaults['default'][field]
            }
            return ''
        },
        insertMissingFields: function(structures, created = false) {
            for (let key in Object.keys(structures)) {
                let structure = structures[key].data

                let properties = this.getPropertiesForType(structure.type)
                if (properties) {
                    for (let [key, def] of Object.entries(properties)) {
                        if (def.computed) {
                            key = def.computed
                        }

                        let value = (typeof _.get(structure, key) !== 'undefined' && _.get(structure, key) !== null) ? _.get(structure, key) : this.defaultValue(structure.type, key, created)
                        _.set(structure, key, value)
                    }
                    if (created && Object.keys(properties).includes('duration_type')) {
                        if (Object.keys(properties).includes('display_runs')) {
                            structure['duration_type'] = 2
                        } else {
                            structure['duration_type'] = 1
                        }
                    }
                }
            }
        },
        getPropertiesForType: function(type) {
            type = type ?? 'base'
            return this.loadDefinitionForType(type)
        },
        loadDefinitionForType: function(type) {
            let prefix = 'p_'
            if (type === undefined) {
                return
            }

            let properties = []
            if (elementsSettingsDefinition[type] !== undefined && elementsSettingsDefinition[prefix + type] !== undefined) {
                Object.assign(properties, elementsSettingsDefinition[type], elementsSettingsDefinition[prefix + type])
            } else if (elementsSettingsDefinition[type] !== undefined) {
                properties = elementsSettingsDefinition[type]
            } else if (elementsSettingsDefinition[prefix + type] !== undefined) {
                properties = elementsSettingsDefinition[prefix + type]
            }
            return properties
        }
    },
    mounted() {
        const localStorageLayoutKey = `publish-layout-${Laravel.activeProject}`;
        const layout = localStorage.getItem(localStorageLayoutKey);
        this.layout = layout ? layout : 'editor-right';

        this.publishError = this.userStatusErrored;
        EaseEventBus.listen('serverErrorChanged', (value) => {
            this.publishError = value;
        });

        EaseEventBus.listen(localStorageLayoutKey, (val) => this.layout = val);

        let grid = localStorage.getItem('publish-grid-' + Laravel.activeProject)
        if (grid !== null) {
            this.grid = grid
        } else {
            this.grid = '2cols'
        }
        this.setStartCollapse()

        EaseEventBus.listen('reinitializeDragula', () => {
            if (this.dragulaObject !== null) {
                this.dragulaObject.destroy()
            }

            this.setupDragula()

            EaseEventBus.fire('doneReinitializeDragula')

            if (this.inserted === false) {
                this.inserted = true;

                if (_.size(this.insert_data) > 0) {
                    let state = 'unknown'
                    let searchLayer = this.active_layers[localStorage.getItem('publish-layer-' + Laravel.activeProject)];

                    if (this.insert_data.inline) {
                        state = 'inline'
                    } else
                    if (_.indexOf(['campaign', 'template'], this.insert_data.type) !== -1) {
                        state = 'link'
                    }

                    const structure = {
                        id: this.insert_data.id,
                        name: this.insert_data.name,
                        type: this.insert_data.type,
                        background_image: this.insert_data.picture,
                        loop: 0,
                        state: state,
                        valid_from: this.insert_data.validFrom,
                        valid_to: this.insert_data.validTo,
                        valid_time_from: this.insert_data.validTimeFrom,
                        valid_time_to: this.insert_data.validTimeTo,
                    }

                    if (['picture', 'video', 'pdf', 'ppt', 'template', 'campaign'].includes(structure.type)) {
                        structure.transition = this.transition ? this.transition : '1';
                    }

                    if(['picture', 'video', 'pdf', 'ppt'].includes(structure.type)) {
                        structure.stretch = this.stretch ?? 'aspect_fit';
                    }

                    let structures = [{ 'data': structure }]
                    this.insertMissingFields(structures, true)
                    if (this.insert_data.x !== '-1' && this.insert_data.y !== '-1') {
                        if (_.size(searchLayer) > 0) {
                            this.$nextTick(() => {
                                this.addElementToLayer(searchLayer.id, structure)
                            })
                        }
                    }
                }
            }
        })

        EaseEventBus.listen('settingsCollapsed', function(collapsed) {
            localStorage.setItem('publish-settings-collapsed-' + Laravel.activeProject, collapsed)
        })

        EaseEventBus.listen('dragdropCollapsed', function(collapsed) {
            localStorage.setItem('publish-dragdrop-collapsed-' + Laravel.activeProject, collapsed)
        })

        EaseEventBus.listen('settingsActive', function() {
            localStorage.setItem('publish-settings-active-' + Laravel.activeProject, true)
        })

        EaseEventBus.listen('dragdropActive', function() {
            localStorage.setItem('publish-settings-active-' + Laravel.activeProject, false)
        })

        EaseEventBus.listen('updateActiveLayer', (data) => {
            this.active_layer = _.extend({}, this.active_layer, data)
        })

        EaseEventBus.listen('loadedLayer', () => {
            if (this.active_layer) {
                let structures = this.active_layer.elements;
                this.insertMissingFields(structures);
            }
            EaseEventBus.fire('finishedLoadingLayer')
        })

        EaseEventBus.listen('newContent', (media_type) => {
            if (media_type === 'mediaplaceholder') {
                window.location = '/content/mediapool?add=media&x=0&y=0'
            } else if (media_type === 'templateplaceholder') {
                this.handleTemplateInlineAdd()
            } else if (media_type === 'campaignplaceholder') {
                this.handleCampaignInlineAdd()
            }
        })

        EaseEventBus.listen('startLoadingLayer', () => {
            this.loadingProcess = true;
        });
        EaseEventBus.listen('finishedLoadingLayer', () => {
            this.$nextTick(() => {
                this.loadingProcess = false;
            });
        });

        this.appendDragdropAndSettings()
        this.spreadLayoutInfo()
        this.processWindowSize()
        this.$nextTick(() => {
            window.addEventListener('resize', this.processWindowSize)
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.processWindowSize)
    }
}
</script>
